module.exports = __webpack_public_path__ + "static/media/stripHalfCircleYellow2.800d9cc0.svg";